<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 8.5V23.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 14C11.1716 14 10.5 14.6716 10.5 15.5V16.5C10.5 17.3284 11.1716 18 12 18H17C17.8284 18 18.5 17.3284 18.5 16.5V15.5C18.5 14.6716 17.8284 14 17 14H12Z" fill="currentColor"/>
</svg>
